import View from '../../../../../../components/Blocks/EventMetadata/View';
export default View;
